function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.19 -5.19)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 143.01,
  cy: 143.01,
  r: 143.01,
  transform: "translate(63.41 62.57)",
  fill: "#fff",
  stroke: "#ccc",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "ring-yellow",
  cx: 164,
  cy: 164,
  r: 164,
  transform: "translate(41.5 41.5)",
  fill: "none",
  stroke: "#f6cc54",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "ring-teal",
  cx: 185.31,
  cy: 185.31,
  r: 185.31,
  transform: "translate(20.19 20.19)",
  fill: "none",
  stroke: "#008daf",
  strokeWidth: 30
}));

var SvgResultsChart = function SvgResultsChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "transform -rotate-90",
    x: "0px",
    y: "0px",
    viewBox: "0 0 412 412",
    style: {
      enableBackground: "new 0 0 412 412"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResultsChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/results-chart.442adcf4.svg";
export { ForwardRef as ReactComponent };